import { Carousel } from "@asosteam/asos-web-component-library-carousel";
import { useState } from "react";
import { useDrawDetails } from "../../context/draw-details";
import { Gallery } from "../gallery";
import styles from "./styles";

export const Hero = () => {
  const [state] = useDrawDetails();
  const productImages = state?.content?.productImages ?? [];

  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 75) {
      document
        .querySelectorAll('button[class*="styles-module_next__"]')[0]
        .click();
    }

    if (touchStart - touchEnd < -75) {
      document
        .querySelectorAll('button[class*="styles-module_previous__"]')[0]
        .click();
    }
  };

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.carousel}
        id="hero-carousel"
        onTouchStart={(e) => handleTouchStart(e)}
        onTouchMove={(e) => handleTouchMove(e)}
        onTouchEnd={() => handleTouchEnd()}
      >
        <Carousel
          aria-label="Product image carousel"
          ariaDescribedby="hero-carousel"
          itemsPerRow={1}
          paginationLabel="Carousel navigation dots"
          paginationLabelNoNext="Carousel controls no next button"
          paginationLabelNoPrevious="Carousel controls no previous button"
          paginationTabLabel={() => {}}
          paginationTabPanelLabel={() => {}}
        >
          {productImages &&
            productImages
              .filter(Boolean)
              .map((image) => (
                <img
                  src={image.src}
                  height={image.height}
                  width={image.width}
                  alt={image.alt}
                  key={image.alt}
                />
              ))}
        </Carousel>
      </div>
      <div className={styles.gallery}>
        <Gallery />
      </div>
    </div>
  );
};
